// จัดชนิดไฟล์เพื่อเลือกวิธีพรีวิว
//
// ดูทั้ง mime และนามสกุล เพราะบาง browser/บาง OS ส่ง type ของ File มาเป็นค่าว่าง
// แล้วเราเก็บเป็น application/octet-stream ทั้งที่จริงเป็น xlsx
export type FileKind = "image" | "pdf" | "sheet" | "slides" | "doc" | "text" | "other";

const BY_EXT: Record<string, FileKind> = {
  png: "image",
  jpg: "image",
  jpeg: "image",
  gif: "image",
  webp: "image",
  svg: "image",
  avif: "image",
  bmp: "image",
  pdf: "pdf",
  xlsx: "sheet",
  xlsm: "sheet",
  xls: "sheet",
  csv: "sheet",
  pptx: "slides",
  ppt: "slides",
  docx: "doc",
  doc: "doc",
  txt: "text",
  md: "text",
  json: "text",
};

export const extOf = (name: string) => (name.split(".").pop() ?? "").toLowerCase();

export function fileKind(doc: { name: string; mime: string }): FileKind {
  const m = (doc.mime || "").toLowerCase();
  if (m.startsWith("image/")) return "image";
  if (m === "application/pdf") return "pdf";
  if (m.startsWith("text/") && m !== "text/csv") return "text";
  return BY_EXT[extOf(doc.name)] ?? "other";
}

/** ชนิดที่เปิดดูในหน้าเว็บได้ — ที่เหลือทำได้แค่บอกรายละเอียดแล้วให้ดาวน์โหลด */
export function canPreview(kind: FileKind): boolean {
  return kind !== "other";
}

const KIND_LABEL: Record<FileKind, string> = {
  image: "รูปภาพ",
  pdf: "PDF",
  sheet: "ตาราง",
  slides: "สไลด์",
  doc: "เอกสาร",
  text: "ข้อความ",
  other: "ไฟล์",
};

export const kindLabel = (k: FileKind) => KIND_LABEL[k];

export function fmtBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
